import axiosClient from "axios-client.js";
import { useEffect, useState } from "react";
import CardSx from "./components/CardSx.jsx";
import CardDx from "./components/CardDx.jsx";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loading from "components/loading/Loading";
import { ACTIVATION_TYPES } from "utils/constants.js";
import ThirdCardSx from "./components/ThirdCardSx.jsx";
import SecondCardSx from "./components/SecondCardSx.jsx";
import FourthCardSx from "./components/FourthCardSx.jsx";
import { activationStates } from "../../../variables/activations";

const ActivationSummary = () => {
    const navigate = useNavigate();
    const { code } = useParams();

    const [load, setLoad] = useState(true);
    const [message, setMessage] = useState({});
    const [state, setState] = useState(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });

        setLoad(true);
        setMessage({});

        axiosClient
            .get("/activation/" + code)
            .then(({ data }) => {
                setLoad(false);
                setState(data);
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    }, []);

    function handleEdit() {
        setLoad(true);
        navigate(`/my/activation-${state.type}/${state.code}`, {
            replace: true,
        });
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        setLoad(true);
        setMessage({});

        var status = activationStates.PENDING_CONFIRMATION;

        if (state.type === ACTIVATION_TYPES.ONSITE && !state.data.server_code) {
            status = activationStates.WAITING_FOR_SERVER_CODE;
        }

        axiosClient
            .put("/activation/" + state.code, {
                code: state.code,
                created_at: state.created_at,
                data: state.data,
                id: state.id,
                status: status,
                step: state.step,
                type: state.type,
            })
            .then(() => {
                navigate(`/my/confirm-activation/${state.code}`, {
                    replace: true,
                    state: {
                        type: state.type,
                        status: state.status,
                    },
                });
            })
            .catch((err) => {
                const response = err.response;

                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            })
            .finally(() => {
                setLoad(false);
            });
    };

    return (
        <div>
            {load ? <Loading /> : null}
            <form onSubmit={handleSubmit}>
                <div className="flex gap-5">
                    {message.hasOwnProperty("text") && (
                        <div
                            className={
                                "mb-6 text-left text-base " +
                                (message.type === "SUCCESS"
                                    ? "text-green-500"
                                    : message.type === "ERROR"
                                    ? "text-red-500"
                                    : message.type === "WARNING"
                                    ? "text-amber-500"
                                    : null)
                            }
                        >
                            <p>{message.text}</p>
                        </div>
                    )}

                    {state && (
                        <div className="flex grow flex-col gap-5">
                            <CardSx state={state} />

                            {state.type === ACTIVATION_TYPES.ONSITE ? (
                                <SecondCardSx state={state} />
                            ) : null}

                            <ThirdCardSx state={state} />

                            <FourthCardSx />
                        </div>
                    )}

                    <div className="w-1/4 min-w-[20rem]">
                        <CardDx state={state} handleEdit={handleEdit} />
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ActivationSummary;
